import React from 'react';
import { useTranslation } from 'react-i18next';

const FileList = ({ files, onRemoveFile, onClearFiles, onConvert, isConverting, progress }) => {
  const { t } = useTranslation();
  
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  if (files.length === 0) {
    return (
      <div className="card">
        <div className="card-content">
          <h3>📁 {t('fileList.title')} (0)</h3>
          <p style={{ color: '#757575', textAlign: 'center', padding: '20px' }}>
            {t('fileList.noFiles')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3>📁 {t('fileList.title')} ({files.length})</h3>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button className="btn btn-secondary" onClick={onClearFiles}>
              {t('fileList.clearAll')}
            </button>
            <button
              className="btn"
              onClick={onConvert}
              disabled={isConverting}
              style={{ minWidth: '140px' }}
            >
              {isConverting && <span className="loading"></span>}
              {isConverting ? t('fileList.converting') : t('fileList.convert', { count: files.length })}
            </button>
          </div>
        </div>
      
        {files.map((file, index) => {
          const isCurrentFile = isConverting && progress.currentFile === file.name;
          const isCompleted = isConverting && progress.currentFileIndex > index + 1;
          
          return (
            <div key={index} className={`file-item ${isCurrentFile ? 'current-file' : ''} ${isCompleted ? 'completed-file' : ''}`}>
              <div className="file-info">
                <div className="file-name">
                  {isCompleted ? '✅' : isCurrentFile ? '⏳' : '📖'} {file.name}
                  {isCurrentFile && (
                    <span className="file-status"> ({t('fileList.currentFile')})</span>
                  )}
                  {isCompleted && (
                    <span className="file-status"> ({t('fileList.completed')})</span>
                  )}
                </div>
                <div className="file-size">{formatFileSize(file.size)}</div>
              </div>
              <button
                className="btn btn-danger"
                onClick={() => onRemoveFile(index)}
                style={{ fontSize: '12px', padding: '8px 16px' }}
                disabled={isConverting}
              >
                {t('fileList.remove')}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FileList;
